import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrl: './loading-modal.component.scss'
})
export class LoadingModalComponent {
  text: string;
  icon: string = 'loader';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { text: string; icon: string; },
  ) {
    this.text = data.text;
    this.icon = data.icon || 'loader';

  }
  updateText(newText: string) {
    this.text = newText;
  }
  updateIcon(newIcon: string) {
    this.icon = newIcon;
  }
}
